import { Exception } from './Exception'

export class NetworkException extends Exception {
  constructor() {
    super({
      message: 'Network Error',
      cause: {
        errors: [{ property: 'NetworkError', message: 'Network Error' }],
      },
    })
  }
}
